import React from 'react'
import { GiStarShuriken } from "react-icons/gi"
function Separator() {
  return (
    <div style={{ background: "linear-gradient(to right, #B16CEA 1%, #FF5E69 71%, #FF8A56 91%, #FFA84B 100%)" }} className='h-[60px] sm:h-[70px]'>
      <div className='bg-[var(--white-secondary)] h-[50px] sm:h-[60px] w-[100%] relative -rotate-[2deg] sm:-rotate-[1.5deg] flex items-center gap-x-5 overflow-x-hidden  justify-center'>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Develop</h6>


        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />

        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Discover</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Acheive</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Develop</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Discover</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Acheive</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Develop</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Discover</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Acheive</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Develop</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Discover</h6>
        <GiStarShuriken
          className='min-w-[30px] h-[30px] fill-[#FF5E69]'

        />
        <h6 className='font-bold text-[16.4px] text-[var(--black-secondary)]'>Acheive</h6>
      </div>
    </div>
  )
}

export default Separator